//@ts-check
import request from '../request';
/**
 * Get all tags of a path
 * @param {string} workspace
 * @param {string} path
 * @return {Promise<Array<import("./types").Tag>>}
 */

export var getTags = function getTags(workspace, path) {
  return request({
    url: '/backend/tags',
    query: {
      workspace: workspace,
      path: path
    }
  });
};
/**
 * Add a tag to a path
 * @param {string} workspace
 * @param {string} path
 * @param {import('./types').Tag} tag
 * @return {Promise<void>}
 */

export var addTag = function addTag(workspace, path, tag) {
  return request({
    url: '/backend/tags',
    query: {
      workspace: workspace,
      path: path
    },
    method: 'POST',
    data: tag
  });
};
/**
 * Remove all tags that have the same properties from a path.
 * @param {string} workspace
 * @param {string} path
 * @param {string} name
 * @return {Promise<void>}
 */

export var removeTagsByName = function removeTagsByName(workspace, path, name) {
  return request({
    url: '/backend/tags',
    query: {
      workspace: workspace,
      path: path,
      name: name
    },
    method: 'DELETE'
  });
};
export default {
  getTags: getTags,
  addTag: addTag,
  removeTagsByName: removeTagsByName
};